import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Framework from "@/pages/Framework";
import Diagnostic from "@/pages/Diagnostic";
import Results from "@/pages/Results";
import BoardCreate from "@/pages/BoardCreate";
import BoardResults from "@/pages/BoardResults";
import Directorates from "@/pages/Directorates";
import MemberHub from "@/pages/MemberHub";
import TeamInvite from "@/pages/TeamInvite";
import AboutSteve from "@/pages/AboutSteve";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Benchmark from "@/pages/Benchmark";
import AnnualIndex from "@/pages/AnnualIndex";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/framework" element={<Framework />} />
            <Route path="/diagnostic" element={<Diagnostic />} />
            <Route path="/results/:id" element={<Results />} />
            <Route path="/board/new" element={<BoardCreate />} />
            <Route path="/board/:code/results" element={<BoardResults />} />
            <Route path="/board/:code/directorates" element={<Directorates />} />
            <Route path="/team/:token" element={<MemberHub />} />
            <Route path="/team-invite/:token" element={<TeamInvite />} />
            <Route path="/steve" element={<AboutSteve />} />
            <Route path="/benchmark" element={<Benchmark />} />
            <Route path="/annual-index" element={<AnnualIndex />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}
